import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage, Media, MediaUpload } from "../../../../external-components"
import { RenderConfig, SliderProps } from "./RenderConfig"

const ImageCard = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Image URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${configs.API_URL}${url}` : DefaultImage}
            alt="Slider Image"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const CaoCaoSlider: ComponentConfig<SliderProps> = {
  label: "CaoCao | Slider",
  fields: {
    controlButton: {
      label: "Control Slider Button",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    heightSliderDesktop: {
      label: "Height Slider Desktop",
      type: "text",
    },
    heightSliderMobile: {
      label: "Height Slider Mobile ",
      type: "text",
    },
    gapSlider: {
      label: "Gap",
      type: "text",
    },
    sliderItems: {
      label: "Slider Items",
      type: "array",
      arrayFields: {
        image1: {
          label: "First Image",
          type: "custom",
          render: props => <ImageCard {...props} />,
        },
        image2: {
          label: "Second Image (Optional)",
          type: "custom",
          render: props => <ImageCard {...props} />,
        },
        textField: {
          label: "Text Content",
          type: "object",
          objectFields: {
            country: {
              label: "Country",
              type: "text",
            },
            countryTextSize: {
              label: "Country Text Size",
              type: "text",
            },
            countryTextWeight: {
              label: "Country Text Weight",
              type: "text",
            },
            countryLineHeight: {
              label: "Country Line Height",
              type: "text",
            },
            province: {
              label: "Province",
              type: "text",
            },
            provinceTextSize: {
              label: "Province Text Size",
              type: "text",
            },
            provinceTextWeight: {
              label: "Province Text Weight",
              type: "text",
            },
            provinceLineHeight: {
              label: "Province Line Height",
              type: "text",
            },
          },
        },

        textContainerStyles: {
          label: "Text Container Styles",
          type: "object",
          objectFields: {
            position: {
              label: "Position",
              type: "select",
              options: [
                { label: "Top Left", value: "top-left" },
                { label: "Top Right", value: "top-right" },
                { label: "Bottom Left", value: "bottom-left" },
                { label: "Bottom Right", value: "bottom-right" },
                { label: "Center", value: "center" },
              ],
            },
            fontSize: {
              label: "Font Size",
              type: "text",
            },
            fontWeight: {
              label: "Font Weight",
              type: "select",
              options: [
                { label: "Light", value: "light" },
                { label: "Normal", value: "normal" },
                { label: "Bold", value: "bold" },
                { label: "Extra Bold", value: "extrabold" },
              ],
            },
            color: {
              label: "Text Color",
              type: "text",
            },
            backgroundColor: {
              label: "Background Color",
              type: "text",
            },
            padding: {
              label: "Padding",
              type: "text",
            },
            gap: {
              label: "Gap",
              type: "text",
            },
          },
        },
        mediaStyles: {
          label: "Media Styles",
          type: "object",
          objectFields: {
            width: {
              label: "Width",
              type: "text",
            },
            margin: {
              label: "Margin",
              type: "text",
            },
          },
        },
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  ...RenderConfig,
}
